import React, { useEffect } from "react";
import { StyledHoopsModal, HoopsCloseButton } from "./HoopsModal.style";
import HoopsViewer from "./HoopsViewer";
import fileUtils, { ModelViewerFile } from "../../utils/fileUtils";
import { useConfig } from "../proposals/contexts/configContext";

interface Props {
  is3DViewerModalOpen: boolean;
  streamcacheFileUrl: string | null;
  toggle3DViewerModal: (file?) => void;
  file: ModelViewerFile | null;
}

const renderHoopsViewer = (
  file: ModelViewerFile | null,
  streamcacheFileUrl: string | null,
  wwwOrigin: string
) => {
  if (file && streamcacheFileUrl) {
    const originalFilename = fileUtils.getOriginalFilename(file);
    const solidModelType = originalFilename.split(".").pop();

    let box;
    let unit;

    // Don't show dimensions for some files until we have a unit toggle for parts
    if (!fileUtils.fileNeedUserInputForUnits(file)) {
      box = file?.geometry?.boundingBox;
      unit = file?.geometry?.unit;
    }

    return (
      <HoopsViewer
        url={streamcacheFileUrl}
        solidModelType={solidModelType}
        box={box}
        boxUnit={unit}
        originalFilename={originalFilename}
        wwwOrigin={wwwOrigin}
      />
    );
  }
};

const HoopsModal: React.FC<Props> = ({
  streamcacheFileUrl,
  is3DViewerModalOpen = false,
  toggle3DViewerModal,
  file = null,
}) => {
  const closeButtonRef = React.createRef<HTMLButtonElement>();

  useEffect(() => {
    if (is3DViewerModalOpen && closeButtonRef.current) {
      closeButtonRef.current.focus();
    }
  }, [is3DViewerModalOpen]);

  const { origins } = useConfig();

  return (
    <>
      <div id="model-viewer-modal-container" />
      <StyledHoopsModal
        isOpen={is3DViewerModalOpen}
        selector="#model-viewer-modal-container"
      >
        <HoopsCloseButton
          ref={closeButtonRef}
          onClick={() => toggle3DViewerModal()}
        >
          Close
        </HoopsCloseButton>
        {is3DViewerModalOpen &&
          renderHoopsViewer(file, streamcacheFileUrl, origins.www)}
      </StyledHoopsModal>
    </>
  );
};

export default HoopsModal;
